module.exports = __webpack_public_path__ + "static/media/speaker1.666572e0.jpg";